module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1@2-df13f834dc0851721dfd91fbfa706c3a.jpg";